import { learningContents } from '@/mocks/advancedCourseData';
import { useTranslation } from 'react-i18next';

const LEARNING_COUNT = 6;
const learningIndices = Array.from({ length: LEARNING_COUNT }, (_, i) => i);

const imageUrls: Record<string, string> = {
  'advanced-service': '/images/generated/advanced-service-2026.jpg',
  'advanced-wine': '/images/generated/advanced-glass-polish-2026.jpg',
  'advanced-event': '/images/generated/advanced-event-2026.jpg',
  'advanced-table': '/images/generated/advanced-candlelight-2026.jpg',
  'advanced-international': '/images/generated/advanced-international-2026.jpg',
  'advanced-garment': '/images/generated/advanced-garment-2026.jpg',
};

export default function LearningContent() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-16">
          {String(t('coursesAdvanced.learning.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesAdvanced.learning.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {String(t('coursesAdvanced.learning.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] max-w-xl mx-auto leading-relaxed">{__s}</p>))}
        </div>

        {/* Zigzag Content */}
        <div className="space-y-16 md:space-y-24">
          {learningIndices.map((index) => {
            const item = learningContents[index];
            const isEven = index % 2 === 0;
            const title = t(`coursesAdvanced.learning.${index}.title`);
            return (
              <div
                key={index}
                className={`flex flex-col ${isEven ? 'md:flex-row' : 'md:flex-row-reverse'} gap-8 md:gap-12 items-center`}
              >
                {/* Image Side */}
                <div className="w-full md:w-1/2">
                  <div className="overflow-hidden">
                    <img
                      src={imageUrls[item?.imageSeq ?? '']}
                      alt={t('coursesAdvanced.learning.imgAlt').replace('{title}', title)}
                      title={t('coursesAdvanced.learning.imgTitle').replace('{title}', title)}
                      className="w-full object-cover object-top transition-transform duration-700 hover:scale-105"
                    />
                  </div>
                  <div className="mt-3 h-[1px] bg-gradient-to-r from-transparent via-accent-500/20 to-transparent"></div>
                </div>

                {/* Text Side */}
                <div className="w-full md:w-1/2">
                  <div className="flex items-center gap-4 mb-4">
                    <span className="w-10 h-10 flex items-center justify-center">
                      <i className={`${item?.icon} text-accent-600 text-xl`}></i>
                    </span>
                    <div>
                      <p className="text-[12px] text-accent-500/70 tracking-[0.15em] font-label mb-1">
                        {t(`coursesAdvanced.learning.${index}.titleEn`).toUpperCase()}
                      </p>
                      <h3 className="font-heading text-lg text-foreground-900 tracking-[0.06em]">
                        {title}
                      </h3>
                    </div>
                  </div>
                  <p className="text-[16px] text-foreground-700 leading-relaxed tracking-[0.03em]">
                    {t(`coursesAdvanced.learning.${index}.description`)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
